import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../api/api.service';

export interface ClassificationReviewAISuggestions {
  categoryId?: number;
  typeId?: number;
  owner?: string;
  detail?: string;
  issuer?: string;
  documentDate?: string | null;
  taxYear?: string | null;
  generatedFilename?: string;
}

export interface ClassificationReviewDetails {
  documentId: string;
  originalFilename: string;
  owner: string;
  householdId: string;
  organizationId: string;
  aiCategorization: ClassificationReviewAISuggestions;
  aiProcessedAt: string;
  status: string;
  documentCreatedAt?: string;
  documentUpdatedAt?: string;
}

export interface ClassificationApprovalPayload {
  categoryId?: number;
  typeId?: number;
  owner?: string;
  detail?: string;
  issuer?: string;
  documentDate?: string | null;
  taxYear?: string | null;
  generatedFilename?: string;
}

export interface ApprovalResponse {
  message: string;
  documentId: string;
  status: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClassificationReviewService {
  private readonly baseUrl = 'approval/categorization-review';

  constructor(private apiService: ApiService) {}

  /**
   * Get detailed categorization review for a specific document
   * @param documentId - The document ID to retrieve
   * @returns Promise with classification review details including AI suggestions
   */
  async getReviewDetails(documentId: string): Promise<ClassificationReviewDetails> {
    return this.apiService.call<ClassificationReviewDetails>(
      HttpMethod.GET,
      `${this.baseUrl}/${documentId}`
    );
  }

  /**
   * Approve categorization with final data (with or without corrections)
   * @param documentId - The document ID to approve
   * @param payload - The categorization data (AI suggestions or user corrections)
   * @returns Promise with approval response
   */
  async approveClassification(
    documentId: string,
    payload: ClassificationApprovalPayload
  ): Promise<ApprovalResponse> {
    return this.apiService.call<ApprovalResponse>(
      HttpMethod.POST,
      `${this.baseUrl}/${documentId}`,
      payload
    );
  }
}
